import { createStyles, Text } from "@mantine/core";
import { PropsWithChildren } from "react";

const useLabelStyles = createStyles((theme) => ({
  labelText: {
    fontFamily: theme.fontFamily,
    fontWeight: theme.other.fontWeights.semibold,
    fontSize: theme.fontSizes.md,
    lineHeight: theme.lineHeight,
  },
  bodyText: {
    fontFamily: theme.fontFamily,
    fontWeight: theme.other.fontWeights.normal,
    fontSize: theme.fontSizes.md,
    lineHeight: theme.other.sizes["body-text-lineheight"],
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export function RpiLabelText({ children }: PropsWithChildren) {
  const { classes } = useLabelStyles();
  return <Text className={classes.labelText}>{children}</Text>;
}

export function RpiBodyText({ children }: PropsWithChildren) {
  const { classes } = useLabelStyles();
  return <Text className={classes.bodyText}>{children}</Text>;
}
